import * as Sentry from "@sentry/react";
import { getSentryConfig } from "./config.js";
export function initSentryReact() {
    const config = getSentryConfig();
    if (!config.enabled) {
        return;
    }
    Sentry.init({
        dsn: config.dsn,
        environment: config.environment,
        tracesSampleRate: config.tracesSampleRate,
        profilesSampleRate: config.profilesSampleRate,
        release: config.release,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],
    });
}
export function setSentryUser(user) {
    Sentry.setUser(user);
}
export function captureException(error, context) {
    Sentry.captureException(error, {
        extra: context,
    });
}
export function captureMessage(message, level = "info") {
    Sentry.captureMessage(message, level);
}
//# sourceMappingURL=react.js.map